import { render, staticRenderFns } from "./QueryStat.vue?vue&type=template&id=502c2480&"
import script from "./QueryStat.vue?vue&type=script&lang=js&"
export * from "./QueryStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports